import React from "react";
import PropTypes from "prop-types";
import classes from "./pie.module.scss";
import {
  PieChart,
  Pie,
  Sector,
  Cell,
  Legend,
  Label,
  ResponsiveContainer,
} from "recharts";

function PieChartComponent(props) {
  //const data = props.data;

  const data = [
    { name: "Сільське госп.", value: 685 },
    { name: `Житлово-ком. госп.`, value: 154 },
    { name: "Промисловість", value: 161 },
  ];
  const COLORS = [
    "#0088FE",
    "#00C49F",
    "#FFBB28",
    "#FF8042",
    "#FF2092",
    "#8884d8",
  ];

  const RADIAN = Math.PI / 180;
  const renderCustomizedLabel = ({
    cx,
    cy,
    midAngle,
    innerRadius,
    outerRadius,
    percent,
    index,
  }) => {
    const radius = innerRadius + (outerRadius - innerRadius) * 0.2;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);

    return (
      <text
        x={x}
        y={y}
        fill="black"
        textAnchor={x > cx ? "start" : "end"}
        dominantBaseline="central"
      >
        {`${(percent * 100).toFixed(0)}%`}
      </text>
    );
  };
  return (
    <div className={classes.wrapper}>
      <h2 className={classes.title}>Діаграма споживання вод</h2>
      <ResponsiveContainer width={400} height="100%">
        <PieChart margin={{ top: 25, right: 25, left: 25, bottom: 25 }}>
          <Pie
            data={data}
            labelLine={false}
            label={renderCustomizedLabel}
            innerRadius={60}
            cx="53%"
            outerRadius={100}
            fill="#8884d8"
            paddingAngle={5}
          >
            {data.map((entry, index) => (
              <Cell fill={COLORS[index % COLORS.length]} />
            ))}
          </Pie>
          <Legend
            align="left"
            verticalAlign="middle"
            layout="vertical"
            iconSize={25}
          />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
}

PieChartComponent.propTypes = {
  data: PropTypes.array.isRequired,
  maxLine: PropTypes.object,
};

export default PieChartComponent;
